module.exports = __webpack_public_path__ + "img/btn_power4_n.e5de29d6.png";